<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { maskCpfCnpj, maskPhone, validateCpfCnpj } from "@/utils/masks";
import QRCode from "qrcode";
import AdesaoGateModal from "./components/AdesaoGateModal.vue";

export default {
  components: { Layout, AdesaoGateModal },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,

      modalVisible: false,
      modalLoading: false,
      modalError: "",
      editingId: null,

      form: {
        name: "",
        email: "",
        cellphone: "",
        note: "",
        document: "",
        password: "",
        status: "active",
      },

      fields: [
        { key: "name",             label: "Nome" },
        { key: "document",         label: "CPF/CNPJ" },
        { key: "email",            label: "E-mail" },
        { key: "cellphone",        label: "Celular" },
        { key: "note",             label: "Observação" },
        { key: "status",           label: "Status" },
        { key: "actions",          label: "Ações" },
      ],

      inviteModal: false,
      inviteLink: "",
      showQrModal: false,
      qrDataUrl:   "",

      activateModal:      false,
      activateItem:       null,
      activateLoading:    false,
      activateError:      "",
    };
  },
  computed: {
    ...mapState({ account: (s) => s.account }),
    cpfState() {
      const digits = this.form.document.replace(/\D/g, "");
      if (!digits) return null;
      if (digits.length < 11 || digits.length === 12 || digits.length === 13) return null;
      return validateCpfCnpj(this.form.document);
    },
    baseUrl() {
      return (process.env.VUE_APP_URL_PAINEL || "").replace(/\/$/, "");
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      api.get("afiliados").then((r) => {
        if (r.data.status === "success") {
          this.list  = r.data.list;
          this.total = r.data.total;
        }
      }).finally(() => { this.loading = false; });
    },

    maskCpfCnpj, maskPhone, // expose to template

    openCreate() {
      this.editingId    = null;
      this.form         = { name: "", email: "", cellphone: "", note: "", document: "", password: "", status: "active" };
      this.modalError   = "";
      this.modalVisible = true;
    },

    openEdit(row) {
      this.editingId  = row.id;
      this.form = {
        name:      row.name,
        email:     row.email,
        cellphone: maskPhone(row.cellphone || ""),
        note:      row.note || "",
        document:  maskCpfCnpj(row.document || ""),
        password:  "",
        status:    row.status,
      };
      this.modalError   = "";
      this.modalVisible = true;
    },

    saveAfiliado() {
      this.modalError = "";

      if (!this.form.document.replace(/\D/g, "")) {
        this.modalError = "Informe o CPF/CNPJ.";
        return;
      }
      if (this.cpfState === false) {
        this.modalError = "CPF/CNPJ inválido.";
        return;
      }

      this.modalLoading = true;
      const body = { ...this.form };

      const request = this.editingId
        ? api.put("afiliados/" + this.editingId, body)
        : api.post("afiliados", body);

      request.then((r) => {
        if (r.data.status === "success") {
          this.modalVisible = false;
          this.load();
        } else {
          this.modalError = r.data.message;
        }
      }).catch((e) => {
        this.modalError = (e.response && e.response.data && e.response.data.message) || "Erro ao salvar afiliado.";
      }).finally(() => { this.modalLoading = false; });
    },

    openActivate(item) {
      this.activateItem  = item;
      this.activateError = "";
      this.activateModal = true;
    },

    doActivate() {
      this.activateError   = "";
      this.activateLoading = true;
      api.put(`afiliados/${this.activateItem.id}/activate`, {})
        .then((r) => {
          if (r.data.status === "success") {
            this.activateModal = false;
            const idx = this.list.findIndex((a) => a.id === this.activateItem.id);
            if (idx !== -1) this.list.splice(idx, 1, r.data.afiliado);
          } else {
            this.activateError = r.data.message || "Erro ao ativar afiliado.";
          }
        })
        .catch(() => { this.activateError = "Erro ao ativar afiliado. Tente novamente."; })
        .finally(() => { this.activateLoading = false; });
    },

    openInvite() {
      const uuid = this.account?.user?.afiliado_invitation_uuid;
      this.inviteLink  = uuid ? `${this.baseUrl}/afiliados/cadastro/${uuid}` : "";
      this.inviteModal = true;
    },

    copyInviteLink() {
      navigator.clipboard.writeText(this.inviteLink).then(() => {
        this.$bvToast.toast("Link copiado!", { variant: "success", autoHideDelay: 2000 });
      });
    },

    shareWhatsApp() {
      const msg = `Olá! Você foi convidado para se tornar um afiliado. Acesse o link para se cadastrar: ${this.inviteLink}`;
      window.open("https://wa.me/?text=" + encodeURIComponent(msg), "_blank");
    },

    async openQrCode() {
      this.qrDataUrl = await QRCode.toDataURL(this.inviteLink, {
        width: 280, margin: 2, color: { dark: "#27416e", light: "#ffffff" },
      });
      this.showQrModal = true;
    },

    downloadQr() {
      const a    = document.createElement("a");
      a.href     = this.qrDataUrl;
      a.download = "convite-afiliado-qrcode.png";
      a.click();
    },

    statusBadge(s) {
      return s === "active" ? "success" : s === "blocked" ? "danger" : "secondary";
    },
    statusLabel(s) {
      return s === "active" ? "Ativo" : s === "blocked" ? "Bloqueado" : "Inativo";
    },
  },
};
</script>

<template>
  <Layout>
    <AdesaoGateModal />
    <div class="page-title-box d-flex align-items-center justify-content-between mb-4">
      <h3 class="mb-0">Meus Afiliados</h3>
      <div>
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="openInvite">
          <i class="mdi mdi-link mr-1"></i> Convidar Afiliado
        </b-button>
        <b-button variant="primary" size="sm" @click="openCreate">
          <i class="mdi mdi-plus mr-1"></i> Cadastrar Afiliado
        </b-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-4">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <b-table stacked="md"
          v-else
          :items="list"
          :fields="fields"
          responsive
          show-empty
          empty-text="Nenhum afiliado cadastrado."
          class="table-hover"
        >
          <template #cell(status)="{ item }">
            <b-badge :variant="statusBadge(item.status)">{{ statusLabel(item.status) }}</b-badge>
            <small v-if="item.status === 'blocked'" class="text-muted d-block">Bloqueado por plano</small>
          </template>
          <template #cell(actions)="{ item }">
            <b-button
              v-if="item.status === 'inactive'"
              size="sm"
              variant="warning"
              class="mr-1"
              @click="openActivate(item)"
            >
              <i class="mdi mdi-account-check-outline mr-1"></i>Ativar
            </b-button>
            <b-button
              v-if="item.status !== 'blocked'"
              size="sm"
              variant="outline-primary"
              @click="openEdit(item)"
            >Editar</b-button>
          </template>
        </b-table>
      </div>
    </div>

    <!-- Create / Edit Modal -->
    <b-modal v-model="modalVisible" :title="editingId ? 'Editar Afiliado' : 'Cadastrar Afiliado'" hide-footer>
      <div v-if="modalError" class="alert alert-danger">{{ modalError }}</div>
      <b-form @submit.prevent="saveAfiliado">
        <b-form-group label="Nome completo *">
          <b-form-input v-model="form.name" required></b-form-input>
        </b-form-group>
        <b-form-group label="E-mail *">
          <b-form-input v-model="form.email" type="email" :disabled="!!editingId" required></b-form-input>
        </b-form-group>
        <b-form-group label="Celular">
          <b-form-input
            :value="form.cellphone"
            placeholder="(00) 00000-0000"
            autocomplete="off"
            @input="form.cellphone = maskPhone($event)"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Observação">
          <b-form-input
            v-model="form.note"
            maxlength="30"
            placeholder="Observação opcional"
            autocomplete="off"
          ></b-form-input>
          <small class="text-muted">{{ form.note.length }}/30 caracteres</small>
        </b-form-group>
        <b-form-group label="CPF/CNPJ *">
          <b-form-input
            :value="form.document"
            :state="cpfState"
            placeholder="000.000.000-00"
            autocomplete="off"
            required
            @input="form.document = maskCpfCnpj($event)"
          ></b-form-input>
          <b-form-invalid-feedback>CPF/CNPJ inválido</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :label="editingId ? 'Nova Senha (deixe em branco para manter)' : 'Senha *'">
          <b-form-input v-model="form.password" type="password" :required="!editingId"></b-form-input>
        </b-form-group>
        <b-form-group label="Status">
          <b-form-select v-model="form.status" :options="[{ value: 'active', text: 'Ativo' }, { value: 'inactive', text: 'Inativo' }]"></b-form-select>
        </b-form-group>
        <div class="text-right mt-3">
          <b-button variant="light" class="mr-2" @click="modalVisible = false">Cancelar</b-button>
          <b-button type="submit" variant="primary" :disabled="modalLoading">
            Salvar
            <b-spinner v-if="modalLoading" small class="ml-1"></b-spinner>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Activate Modal -->
    <b-modal
      v-model="activateModal"
      title="Ativar Afiliado"
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="activateItem" class="mb-3">
        <div class="d-flex align-items-center mb-3 p-3 rounded" style="background:#f8f9fa;">
          <div class="rounded-circle d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
               style="width:40px;height:40px;background:var(--st-brand);color:#fff;font-weight:700;">
            {{ activateItem.name.charAt(0).toUpperCase() }}
          </div>
          <div>
            <div class="font-weight-bold">{{ activateItem.name }}</div>
            <div class="text-muted small">{{ activateItem.email }}</div>
          </div>
        </div>
        <p class="text-muted small mb-3">
          Este afiliado se cadastrou via link de convite e aguarda ativação.
          A comissão é calculada automaticamente (30% do valor da adesão de cada lead convertido).
        </p>
      </div>

      <div v-if="activateError" class="alert alert-danger py-2 small">{{ activateError }}</div>

      <b-form @submit.prevent="doActivate">
        <div class="d-flex justify-content-end mt-3" style="gap:.5rem;">
          <b-button variant="light" @click="activateModal = false">Cancelar</b-button>
          <b-button type="submit" variant="success" :disabled="activateLoading">
            <b-spinner v-if="activateLoading" small class="mr-1"></b-spinner>
            <i v-else class="mdi mdi-account-check-outline mr-1"></i>
            Ativar Afiliado
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Invite Modal -->
    <b-modal v-model="inviteModal" title="Convidar Afiliado" hide-footer>
      <p class="mb-2">Compartilhe o link abaixo para que o afiliado se cadastre:</p>
      <b-input-group class="mb-3">
        <b-form-input :value="inviteLink" readonly></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-secondary" @click="copyInviteLink">
            <i class="mdi mdi-content-copy"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-button variant="outline-primary" block class="mb-2" @click="openQrCode">
        <i class="mdi mdi-qrcode mr-1"></i> Gerar QR Code
      </b-button>
      <b-button variant="success" block @click="shareWhatsApp">
        <i class="mdi mdi-whatsapp mr-1"></i> Compartilhar no WhatsApp
      </b-button>
    </b-modal>

    <!-- QR Code Modal -->
    <b-modal v-model="showQrModal" title="QR Code — Convite de Afiliado" hide-footer centered>
      <div class="text-center py-2">
        <img :src="qrDataUrl" alt="QR Code" style="max-width:280px;border-radius:8px;" />
        <p class="text-muted small mt-3 mb-3">
          Aponte a câmera do celular para o QR Code para acessar o link de cadastro.
        </p>
        <b-button variant="outline-primary" @click="downloadQr">
          <i class="mdi mdi-download mr-1"></i> Baixar imagem
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
